import React from 'react';
import { Container, Content, LoadingBox, SpinnerWrapper } from './styles';

export const SimpleLoading = (props: React.ComponentPropsWithoutRef<typeof LoadingBox>) => (
  <LoadingBox role="progressbar" {...props} />
);

const Loading = (props: React.ComponentPropsWithoutRef<typeof LoadingBox>) => (
  <Container>
    <Content>
      <LoadingBox role="progressbar" {...props} />
    </Content>
  </Container>
);

export const Spinner = (props: React.ComponentPropsWithoutRef<typeof SpinnerWrapper>) => (
  <SpinnerWrapper {...props}>
    <Loading />
  </SpinnerWrapper>
);

export default Loading;
